import User from './models/User';
import Collection from './models/Collection';
import Form from './models/Form';
import Site from './models/Site';
import List from './models/List';
import Communication from './models/Communication';
import Theme from '../app/model/Theme';
import defaultTheme from '../app/theme/default.theme';

export default class InitialState {
  loading = true;

  user: User | null = null;

  collections: Collection[] = [];

  forms: Form[] = [];

  lists: List[] = [];

  selectedSite: Site | null = null;

  selectedList: List | null = null;

  communications: Communication[] = [];

  selectedCommunication: Communication | null = null;

  communicationsShowOnlyDisplayed = false;

  theme: Theme = defaultTheme;
}
